import api from '@/services/api'
import store from '../index'

export default {
  state: {},

  mutations: {},

  actions: {
    async saveUser({ commit }, user) {
      try {
        const { clientId } = store.getters.user

        return await api.post(`/${clientId}/users`, user)
      } catch (error) {
        throw error
      }
    },

    async getUsers({ commit }) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(`/${clientId}/users`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getUser({ commit }, userId) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(`/${clientId}/users/${userId}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateUser({ commit }, user) {
      try {
        const { clientId } = store.getters.user

        return await api.put(`/${clientId}/users/${user.id}`, user)
      } catch (error) {
        throw error
      }
    },

    async updatePassword({ commit }, user) {
      try {
        const { clientId } = store.getters.user

        return await api.put(`/${clientId}/users/${user.userId}/password`, user)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
